// extracted by mini-css-extract-plugin
export var center = "_1b-2";
export var clickableRow = "_1b-5";
export var expandedRow = "_1b-7";
export var hoverable = "_1b-4";
export var left = "_1b-1";
export var right = "_1b-3";
export var row = "_1b-0";
export var selectedRow = "_1b-6";
export var summaryRow = "_1b-8";